import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { DatePicker, message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  approveBeneficiaryById,
  getAllRakBeneficiaryList,
  getBankDetailByBeneficiaryId,
  getConformationDetails,
} from "../../service/rak-beneficiary-service";
import {
  deleteUser,
  getTabBankDetailsList,
} from "../../service/profile-ras-service.js";
import {
  notificationStrings,
  openNotificationWithIcon,
} from "../../common/notification-message/notification.js";

import Loading from "../loader/loader.js";
import { Modal } from "react-bootstrap";
import NkHeader from "../../common/nkheader.js";
import NkTable from "../users/nktable.js";
import RakBankModal from "./modals/rak-bank-modal.js";
import RakFilterBy from "./modals/rak-filter-by.js";
import moment from "moment";
import { useHistory } from "react-router-dom";

function DeleteConformation(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure, you want to delete ?</Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          color="primary"
          onClick={() => props.deleterakuser(props.beneficiaryid)}
          disabled={props.buttonLoading}
        >
          {props.buttonLoading ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

function SendConformationModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="common-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter"></Modal.Title>
      </Modal.Header>
      <Modal.Body>Are you sure, you want to approve?</Modal.Body>
      <Modal.Footer>
        <Button
          variant="secondary"
          color="primary"
          onClick={() => props.handleConformation(props.userApprove)}
          disabled={props.buttonloading === true ? true : false}
        >
          {props.buttonloading ? (
            <Loading color="white" width="15px" height="15px" />
          ) : (
            "Yes"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

const RakBeneficiaries = () => {
  const history = useHistory();
  const request = {
    page: 1,
    size: 10,
    fromDate: null,
    toDate: null,
    name: null,
    mobile: null,
    beneficiary: null,
    type: "",
    country: "",
    status: "",
    profileStatus: "",
    isFilter: true,
    typeLength: "",
    countryLength: "",
    statusLength: "",
    applicationId: 1,
  };
  const [filterForm, setfilterForm] = useState(request);
  const [rakTableList, setRakTableList] = useState([]);
  const [rakTableListExcel, setRakTableListExcel] = useState([]);
  const [isTableLoading, setisTableLoading] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showRakBankModal, setshowRakBankModal] = useState(false); // approve and delete modal
  const [deleteModal, setDeleteModal] = useState(false); //delete
  const [bankDetails, setBankDetails] = useState([]); //bank
  const [beneficiaryid, setBeneficiaryid] = useState(); // send  conformation
  const [userApprove, setUserApprove] = useState(); //approve
  const [sizeShow, setSizeShow] = useState();
  const [sendModal, setSendModal] = useState();
  const [searchBy, setSearchBy] = useState("beneficiary");
  const [searchByValue, setSearchByValue] = useState("");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState();
  const buttonRef = useRef(null);
  const csvLink = useRef();
  const [bankrecordStatus, setBankrecordStatus] = useState("");
  const [buttonLoading, setButtonLoading] = useState(false);
  const [delButtonloading, setDelButtonloading] = useState(false);
  const [approveButtonloading, setapproveButtonloading] = useState(false);
  const [type, setType] = useState([]);
  const [country, setCountry] = useState([]);
  const [status, setStatus] = useState();
  const [profileStatus, setProfileStatus] = useState();
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
  });
  const [filterLength, setFilterLength] = useState({
    typeLength: 0,
    countryLength: 0,
    statusLength: 0,
    profileStatusLength: 0,
  });
  const [noOfFiltersSelected, setNoOfFiltersSelected] = useState();
  // placeholders
  let searchByValuePlaceholder = "";
  if (searchBy === "beneficiary") {
    searchByValuePlaceholder = "Amit Pandit";
  } else if (searchBy === "mobile") {
    searchByValuePlaceholder = "971xxxxxxxxx";
  } else {
    searchByValuePlaceholder = "Amit Pandit";
  }
  const columnsCsv = [
    { key: "registrationDate", label: "Date" },
    { key: "fullName", label: "Full Name" },
    { key: "phoneNumber", label: "Mobile" },
    { key: "beneficiary", label: "Beneficiary" },
    { key: "transfertype", label: "Type" },
    { key: "countryName", label: "Country" },
    { key: "recordStatus", label: "Status" },
  ];

  useEffect(() => {
    if (filterForm && filterForm.isFilter) {
      setisTableLoading(false);
      getAllRakBeneficiaryTableList(filterForm);
    }
  }, [filterForm]);

  const getAllRakBeneficiaryTableList = (request) => {
    request["status"] = request.status.length == 0 ? "" : request.status;
    request["type"] = request.type.length == 0 ? "" : request.type;
    request["country"] = request.country.length == 0 ? "" : request.country;
    request["profileStatus"] =
      request.profileStatus.length == 0 ? "" : request.profileStatus;
    request.size = sizeShow || 10;
    setisTableLoading(true);
    getAllRakBeneficiaryList(request)
      .then((getAllRakBeneficiaryListRes) => {
        setisTableLoading(false);
        if (
          getAllRakBeneficiaryListRes &&
          getAllRakBeneficiaryListRes.data &&
          getAllRakBeneficiaryListRes.data.beneficiaries
        ) {
          setRakTableList(getAllRakBeneficiaryListRes.data.beneficiaries || []);
          setPagination({
            ...pagination,
            pageSize: sizeShow || 10,
            total: getAllRakBeneficiaryListRes.data.totalCount,
            current: request.page,
          });
        }
      })
      .catch((getAllRakBeneficiaryListErr) => {
        setPagination({ ...pagination, pageSize: 10, total: 0, current: 1 });
        setisTableLoading(false);
        setRakTableList([]);
      });
  };

  const handleChangesPath = (data) => {
    let states = { ...data };
    history.push({
      pathname: "/admin/user-profile",
      state: { id: states.userId },
    });
  };

  const handleFIlter = () => {
    let request = {};
    if (searchBy === "name") {
      request = {
        ...filterForm,
        name: searchByValue.trim(),
        mobile: null,
        beneficiary: null,
      };
    } else if (searchBy === "mobile") {
      request = {
        ...filterForm,
        mobile: searchByValue.trim(),
        name: null,
        beneficiary: null,
      };
    } else if (searchBy === "beneficiary") {
      request = {
        ...filterForm,
        beneficiary: searchByValue.trim(),
        mobile: null,
        name: null,
      };
    }

    if (filterForm && filterForm.country && filterForm.country.length > 0) {
      let a = "";
      filterForm &&
        filterForm.country &&
        filterForm.country.forEach((v, i) => {
          console.log(v);
          a = a + v.value + (i + 1 < filterForm.country.length ? "," : "");
        });
      request.country = a || "";
      request.countryLength = filterForm.country.length;
    } else {
      request.country = filterForm.country || "";
      request.countryLength = "";
    }

    if (filterForm && filterForm.status && filterForm.status.length > 0) {
      let a = "";
      filterForm &&
        filterForm.status &&
        filterForm.status.forEach((v, i) => {
          console.log(v);
          a = a + v.value + (i + 1 < filterForm.status.length ? "," : "");
        });
      request.status = a || "";
      request.statusLength = filterForm.status.length;
    } else {
      request.status = filterForm.status || "";
      request.statusLength = "";
    }
    if (
      filterForm &&
      filterForm.profileStatus &&
      filterForm.profileStatus.length > 0
    ) {
      let a = "";
      filterForm &&
        filterForm.profileStatus &&
        filterForm.profileStatus.forEach((v, i) => {
          console.log(v);
          a =
            a + v.value + (i + 1 < filterForm.profileStatus.length ? "," : "");
        });
      request.profileStatus = a || "";
      request.profileStatusLength = filterForm.profileStatus.length;
    } else {
      request.profileStatus = filterForm.profileStatus || "";
      request.profileStatusLength = "";
    }

    if (filterForm && filterForm.type && filterForm.type.length > 0) {
      let a = "";
      filterForm &&
        filterForm.type &&
        filterForm.type.forEach((v, i) => {
          console.log(v);
          a = a + v.value + (i + 1 < filterForm.type.length ? "," : "");
        });
      request.type = a || "";
      request.typeLength = filterForm.type.length;
    } else {
      request.type = filterForm.type || "";
      request.typeLength = "";
    }

    request.fromDate =
      (fromDate && moment(fromDate).format("YYYY-MM-DD")) || null;
    request.toDate =
      (toDate && moment(toDate).format("YYYY-MM-DD")) || moment().format();
    request.searchFilter = "";
    request.page = 1;
    request.isFilter = true;

    setfilterForm(request);
  };

  const columns = [
    {
      dataField: "actions",
      text: "Actions",
      sort: false,
      style: { padding: "0px", textAlign: "center" },
      headerStyle: { textAlign: "center" },

      formatter: (cell, row) => {
        console.log(row && row.status);
        return (
          <>
            {row && row.status === "DELETING" ? null : (
              <>
                {/* approve */}
                {row && row.status === "PENDING" ? (
                  <i
                    className="ni ni-send"
                    style={{ width: "25px", height: "15px", cursor: "pointer" }}
                    onClick={() => {
                      if (row && row.id) {
                        setUserApprove(row.id);
                        setSendModal(true);
                      }
                    }}
                  />
                ) : (
                  <div
                    className="ni"
                    style={{ width: "25px", height: "15px" }}
                  ></div>
                )}
                {/* bank details */}

                <i
                  className="fas fa-university"
                  style={{ height: "15px", cursor: "pointer" }}
                  onClick={() => {
                    if (row && row.id) {
                      getBankDetails(row);
                      setBankrecordStatus(row && row.recordStatus);
                    }
                  }}
                />

                {/* user path */}
                <img
                  alt="..."
                  style={{ width: "25px", height: "15px", cursor: "pointer" }}
                  src={require("assets/img/icons/common/user.svg")}
                  onClick={() => {
                    if (row && row.id) {
                      handleChangesPath(row);
                    }
                  }}
                />
                {/* delete path */}

                <i
                  className="fas fa-trash-alt"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (row && row.id) {
                      setBeneficiaryid(row.id);
                      setDeleteModal(true);
                    }
                  }}
                />
              </>
            )}
          </>
        );
      },
    },
    {
      dataField: "registrationDate",
      text: "Date",
      sort: true,
      style: { minWidth: "100px", textAlign: "Left" },
      formatter: (cell, row) => {
        return moment((row && row.registrationDate) || null).format(
          "DD-MM-YY  HH:mm:ss"
        );
      },
    },
    {
      dataField: "fullName",
      text: "Full Name",
      sort: false,
      style: { minWidth: "150px", textAlign: "left" },
    },

    {
      dataField: "phoneNumber",
      text: "Mobile Number",
      sort: false,
      style: { minWidth: "150px", textAlign: "center" },
      headerStyle: { textAlign: "center" },
    },
    {
      dataField: "beneficiary",
      text: "Beneficiary",
      sort: false,
      style: { maxWidth: "150px", textAlign: "Left" },
      headerStyle: { textAlign: "left" },
    },
    {
      dataField: "transfertype",
      text: "Type",
      sort: false,
      style: { minWidth: "150px", textAlign: "Left" },
    },

    {
      dataField: "countryName",
      text: "Country",
      sort: false,

      headerStyle: { textAlign: "center" },
      style: { minWidth: "150px", textAlign: "center" },
    },
    {
      dataField: "profileStatus",
      text: "RMT Profile",
      sort: false,
      style: { minWidth: "120px", textAlign: "Left" },
    },
    {
      dataField: "recordStatus",
      text: "Status",
      sort: false,
      style: { minWidth: "120px", textAlign: "Left" },
    },
    // {
    //   dataField: "PartnerReference",
    //   text: "Ding Transaction Ref Number",
    //   sort: false,
    //   style: { minWidth: "150px", textAlign: "Left" },
    //   formatter: (cell, row) => {
    //     console.log(row && row.status);
    //     return (
    //       <>
    //         {row && row.status === "DELETING" ? null : (
    //           <>
    //             {/* approve */}
    //             {row && row.status === "PENDING" ? (
    //               <i
    //                 className="ni ni-send"
    //                 style={{ width: "25px", height: "15px", cursor: "pointer" }}
    //                 onClick={() => {
    //                   if (row && row.id) {
    //                     setUserApprove(row.id);
    //                     setSendModal(true);
    //                   }
    //                 }}
    //               />
    //             ) : (
    //               <div
    //                 className="ni"
    //                 style={{ width: "25px", height: "15px" }}
    //               ></div>
    //             )}
    //             {/* bank details */}

    //             <i
    //               className="fas fa-university"
    //               style={{ height: "15px", cursor: "pointer" }}
    //               onClick={() => {
    //                 if (row && row.id) {
    //                   getBankDetails(row);
    //                   setBankrecordStatus(row && row.recordStatus);
    //                 }
    //               }}
    //             />

    //             {/* user path */}
    //             <img
    //               alt="..."
    //               style={{ width: "25px", height: "15px", cursor: "pointer" }}
    //               src={require("assets/img/icons/common/user.svg")}
    //               onClick={() => {
    //                 if (row && row.id) {
    //                   handleChangesPath(row);
    //                 }
    //               }}
    //             />
    //             {/* delete path */}

    //             <i
    //               className="fas fa-trash-alt"
    //               style={{ cursor: "pointer" }}
    //               onClick={() => {
    //                 if (row && row.id) {
    //                   console.log("row details", row);
    //                   setBeneficiaryid(row.id);
    //                   setDeleteModal(true);
    //                 }
    //               }}
    //             />
    //           </>
    //         )}
    //       </>
    //     );
    //   },
    // },
  ];

  const onExcelClciked = (filterForm) => {
    let request = filterForm;
    request.page = 1;
    request.size = "";
    request["status"] = request.status.length == 0 ? "" : request.status;
    request["type"] = request.type.length == 0 ? "" : request.type;
    request["country"] = request.country.length == 0 ? "" : request.country;
    request["profileStatus"] =
      request.profileStatus.length == 0 ? "" : request.profileStatus;
    request.size = null;
    // setisTableLoading(true);
    getAllRakBeneficiaryList(request)
      .then((getAllRakBeneficiaryListRes) => {
        // setisTableLoading(false);
        if (
          getAllRakBeneficiaryListRes &&
          getAllRakBeneficiaryListRes.data &&
          getAllRakBeneficiaryListRes.data.beneficiaries
        ) {
          let data = getAllRakBeneficiaryListRes.data.beneficiaries.map(
            (element) => {
              element.registrationDate = moment(
                element.registrationDate
              ).format("DD-MM-YYYY");
              return element;
            }
          );
          setRakTableListExcel(data || []);
          buttonRef.current.click();
        }
      })
      .catch((getAllRakBeneficiaryListErr) => {
        // setisTableLoading(false);
        setRakTableListExcel([]);
      });
  };

  //delete user api
  const deleterakuser = (id) => {
    setButtonLoading(true);
    deleteUser(id)
      .then((res) => {
        setDeleteModal(false);
        setButtonLoading(false);
        //message.success("Delete Successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Delete Successfully"
        );
        getAllRakBeneficiaryTableList(filterForm, id);
      })
      .catch((err) => {
        setDeleteModal(false);
        //openNotificationWithIcon(notificationStrings.error, err);
        setButtonLoading(false);
      });
  };
  //send conformation api
  const handleConformation = (id) => {
    setButtonLoading(true);
    getConformationDetails(id)
      .then((res) => {
        console.log(res);
        setSendModal(false);
        setButtonLoading(false);
        openNotificationWithIcon(
          notificationStrings.success,
          "Send confirmation Successfully"
        );
        //message.success("Send confirmation Successfully");
        getAllRakBeneficiaryTableList(filterForm, id);
      })
      .catch((err) => {
        setButtonLoading(false);
        openNotificationWithIcon(notificationStrings.error, err);
        setSendModal(false);
      });
  };
  // bank details api
  const getBankDetails = (row) => {
    console.log(row);
    console.log(row && row.id);
    getTabBankDetailsList(row && row.id)
      .then((res) => {
        if (res && res.data && res.data.length > 0) {
          setshowRakBankModal(true);
          setBankDetails(res && res.data[0]);
        } else {
          message.error("No bank details found");
        }
      })
      .catch((err) => {
        setshowRakBankModal(false);
        setBankDetails([]);
      });
  };
  //approve modal api
  const approveClicked = (id) => {
    console.log(id);
    setapproveButtonloading(true);
    approveBeneficiaryById(id)
      .then((res) => {
        setapproveButtonloading(false);
        //message.success("Beneficiary approved successfully");
        openNotificationWithIcon(
          notificationStrings.success,
          "Beneficiary approved successfully"
        );
        console.log({ res });
        setshowRakBankModal(false);
      })
      .catch((err) => {
        setapproveButtonloading(false);
        setshowRakBankModal(false);
      });
  };
  //delete modal api
  const deleteClicked = (id) => {
    setDelButtonloading(true);
    deleteUser(id)
      .then((res) => {
        setDelButtonloading(false);
        openNotificationWithIcon(
          notificationStrings.success,
          "User deleted successfully"
        );
        //message.success("User deleted successfully");
        setshowRakBankModal(false);
        console.log({ res });
      })
      .catch((err) => {
        setDelButtonloading(false);
        //openNotificationWithIcon(notificationStrings.error, err);
        setshowRakBankModal(false);
      });
  };

  const resetFilter = () => {
    setSearchBy("beneficiary");
    setType();
    setCountry();
    setStatus();
    setProfileStatus();
    setSearchByValue("");
    console.log("sgdsau");
    setfilterForm(request);
    console.log(filterForm);
    setFromDate("");
    setToDate("");
    setNoOfFiltersSelected(0);
    setFilterLength({
      typeLength: 0,
      countryLength: 0,
      statusLength: 0,
      profileStatusLength: 0,
    });
    // setRakTableList([]);
    // setRakTableListExcel([]);
    // clearFilter();
  };

  const clearFilter = () => {
    setType();
    setCountry();
    setStatus();
    setProfileStatus();
    setfilterForm({
      ...filterForm,
      type: "",
      country: "",
      status: "",
      typeLength: "",
      countryLength: "",
      statusLength: "",
      profileStatusLength: "",
    });
  };
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;

  return (
    <>
      <Container fluid>
        <NkHeader title="RAK Beneficiaries" />
        <Card>
          <CardBody>
            <Row>
              <Col lg="2" className="beneficiary-filter">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Search by
                  </label>
                  <Input
                    id="exampleFormControlSelect1"
                    type="select"
                    value={searchBy}
                    style={{ height: "27px" }}
                    onChange={(e) => {
                      setSearchByValue("");
                      setSearchBy(e.target.value);
                    }}
                  >
                    <option value="beneficiary">Beneficiary</option>
                    <option value="name">Name</option>
                    <option value="mobile">Mobile</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="2" className="beneficiary-filter">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    Search for
                  </label>
                  <Input
                    id="example3cols2Input"
                    placeholder={searchByValuePlaceholder}
                    type="text"
                    style={{ height: "27px" }}
                    onKeyPress={(e) => e.charCode === 13 && handleFIlter(true)}
                    onChange={(e) =>
                      setSearchByValue(e.target.value && e.target.value)
                    }
                    // value={searchBy}
                    value={searchByValue}
                  />
                </FormGroup>
              </Col>
              <Col lg="2" className="beneficiary-filter">
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    From
                  </Label>
                  <DatePicker
                    placeholder="DD-MM-YY"
                    className="formcontrol-date"
                    onChange={(e, dateString) => {
                      if (dateString && dateString != "") {
                        setFromDate(moment(dateString, dateFormat));
                      } else {
                        setFromDate(null);
                      }
                    }}
                    value={fromDate}
                    format={customFormat}
                  />
                </FormGroup>
              </Col>
              <Col lg="2" className="beneficiary-filter">
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    To
                  </Label>
                  <DatePicker
                    placeholder="DD-MM-YY"
                    className="formcontrol-date"
                    onChange={(e, dateString) => {
                      if (dateString && dateString != "") {
                        setToDate(moment(dateString, dateFormat));
                      } else {
                        setToDate(null);
                      }
                    }}
                    value={toDate}
                    format={customFormat}
                  />
                </FormGroup>
              </Col>

              <div
                lg="1"
                className="form-input-padding"
                style={{ marginTop: "2px" }}
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Filter by
                  </Label>
                  <div>
                    <Button
                      style={{ width: "100%", height: "26px" }}
                      color="primary"
                      type="button"
                      id="example3cols2Input"
                      className="filter-button-beneficiery"
                      onClick={() => setShowFilterModal(true)}
                    >
                      <div>
                        <i className="fas fa-filter"></i>
                      </div>
                    </Button>
                  </div>
                </FormGroup>
                <span style={{ fontSize: 8 }}>
                  {noOfFiltersSelected ? (
                    <>
                      <h6 style={{ display: "flex", alignItems: "center" }}>
                        selected(
                        {noOfFiltersSelected} ){" "}
                        <i
                          className="fas fa-window-close"
                          style={{ cursor: "pointer", paddingLeft: "5px" }}
                          onClick={() => resetFilter()}
                        />
                      </h6>
                    </>
                  ) : (
                    <></>
                  )}
                </span>
              </div>
              <Col
                lg="1"
                style={{ marginTop: "9px" }}
                className="form-input-padding"
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      id="example3cols2Input"
                      type="button"
                      style={{
                        width: "100%",
                        background: "#e91d24",
                        color: "white",
                        height: "26px",
                        border: "1px solid rgb(233, 29, 36)",
                      }}
                      className="filter-button"
                      onClick={() => handleFIlter(true)}
                    >
                      <div>
                        <i className="fas fa-search" />
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
              <Col
                lg="1"
                style={{ marginTop: "9px", padding: "0px 6px" }}
                className="form-input-padding"
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      color="light"
                      type="button"
                      style={{ width: "100%", height: "26px" }}
                      id="example3cols2Input"
                      className="filter-button"
                      onClick={() => resetFilter()}
                    >
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        {" "}
                        <i className="fas fa-redo-alt 2px"></i> Reset
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Row>
          <div className="col card-parent">
            <Card style={{ padding: "1.25rem 1.5rem" }}>
              {isTableLoading ? (
                <div style={{ textAlign: "center" }}>
                  <Loading />
                </div>
              ) : (
                <>
                  <NkTable
                    dataexcal
                    filename={"rak-beneficiary"}
                    data={rakTableList}
                    dataEXCEL={rakTableListExcel}
                    columns={columns}
                    columnsCsv={columnsCsv}
                    buttonRef={buttonRef}
                    csvLink={csvLink}
                    onExcelClciked={() => onExcelClciked(filterForm)}
                    // onCsvClick={() => onCsvClicked(filterForm)}
                    type="rakbeneficiary"
                    filterdata={filterForm}
                    pagination={pagination}
                    onPagechange={(page) => {
                      setfilterForm({
                        ...filterForm,
                        page: page,
                        isFilter: true,
                      });
                      console.log(filterForm);
                    }}
                    showSizeChanged={(pageSize) => {
                      setSizeShow(pageSize);
                      setfilterForm({ ...filterForm, isFilter: true });
                    }}
                  />
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>

      <RakFilterBy
        show={showFilterModal}
        onHide={() => {
          setShowFilterModal(false);
        }}
        saveButtonClicked={(saveResponse) => {
          console.log(saveResponse);
          let request = { ...filterForm, ...saveResponse, isFilter: false };
          setfilterForm({ ...request });
          setShowFilterModal(false);
        }}
        type={type}
        profileStatus={profileStatus}
        setType={setType}
        country={country}
        setCountry={setCountry}
        status={status}
        setStatus={setStatus}
        setProfileStatus={setProfileStatus}
        setNoOfFiltersSelected={setNoOfFiltersSelected}
        setFilterLength={setFilterLength}
        filterLength={filterLength}
      />

      <RakBankModal
        show={showRakBankModal}
        onHide={() => setshowRakBankModal(false)}
        bankDetails={bankDetails}
        approveClicked={(e) => approveClicked(e)}
        deleteClicked={(e) => deleteClicked(e)}
        delButtonloading={delButtonloading}
        approveButtonloading={approveButtonloading}
        bankrecordStatus={bankrecordStatus}
      />
      <DeleteConformation
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        deleterakuser={deleterakuser}
        beneficiaryid={beneficiaryid}
        buttonLoading={buttonLoading}
      />
      <SendConformationModal
        show={sendModal}
        handleConformation={handleConformation}
        userApprove={userApprove}
        onHide={() => setSendModal(false)}
        buttonLoading={buttonLoading}
      />
    </>
  );
};

export default RakBeneficiaries;
